const KeyMirror = require("keymirror");

// Export types
module.exports = KeyMirror({
    CROQUIS_PURCHASE_BEGIN: true,
    CROQUIS_PURCHASE_SUCCESS: true,
    CROQUIS_PURCHASE_FAIL: true,
    CROQUIS_DELETE_BEGIN: true,
    CROQUIS_DELETE_SUCCESS: true,
    CROQUIS_DELETE_FAIL: true,
    CROQUIS_LOAD_BEGIN: true,
    CROQUIS_LOAD_SUCCESS: true,
    CROQUIS_LOAD_FAIL: true,
    CROQUIS_SAVE_BEGIN: true,
    CROQUIS_SAVE_SUCCESS: true,
    CROQUIS_SAVE_FAIL: true,
    CROQUIS_CREATE_BEGIN: true,
    CROQUIS_CREATE_SUCCESS: true,
    CROQUIS_CREATE_FAIL: true,
    PURCHASED_LOAD_BEGIN: true,
    PURCHASED_LOAD_SUCCESS: true,
    PURCHASED_LOAD_FAIL: true,
    CROQUIS_MEASUREMENT_UPDATE: true,
    CROQUIS_TITLE_UPDATE: true,
    CROQUIS_FETCH_BEGIN: true,
    CROQUIS_FETCH_SUCCESS: true,
    CROQUIS_FETCH_FAIL: true,
    CROQUIS_TESTER_FETCH_SUCCESS: true,
    PURCHASE_UPGRADE_BEGIN: true,
    PURCHASE_UPGRADE_SUCCESS: true,
    PURCHASE_UPGRADE_FAIL: true,
    LOAD_RENDERING_OPTIONS_BEGIN: true,
    LOAD_RENDERING_OPTIONS_SUCCESS: true,
    LOAD_RENDERING_OPTIONS_FAIL: true
});



// WEBPACK FOOTER //
// ./src/action-types/croquis.js